import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

export const useSub = () => {
  const location = useLocation();
  const [ sub, setSub ] = useState("")
  const [searchParams] = useSearchParams();

  useEffect(() => {
    try {
      const sub = searchParams.get('sub');
      setSub(sub)
    } catch (error) {
      console.error('Error setting sub:', error);
    }
  }, [location, setSub]);

  return { sub };
};
